<script lang="ts">
	import { getGlobalSettings } from "../../contexts/getGlobalSettings.js";

	const { RECAPTCHA_SITE_KEY } = getGlobalSettings();

	/* eslint-disable */
</script>

<svelte:head>
	{#if RECAPTCHA_SITE_KEY}
		{@html `<script src="https://www.google.com/recaptcha/api.js" async defer></script>`}
	{/if}
</svelte:head>
